import { useQuery } from 'react-query'
import useSingleStation from '../useSingleStation';
import { getEnergyActiveImportData, getSationData } from '../../services/stationsAPI';
import { useFilterAnalysis } from '../../../../common/analysis/filter/hook';
import { MeasurandData } from '../../types/stations.types';

export default function useStationDataEnergyActiveImport(stationId?: string) {
    const {stationId: stationIdUrl} = useSingleStation() 
  const {filter} = useFilterAnalysis()
    const stationIdFound = stationId || stationIdUrl;

    const energyActiveImportQuery = useQuery({
    queryKey: ['stationDataEnergyActiveImport', stationId, filter],
    queryFn: () => getEnergyActiveImportData(stationIdFound || "none", filter),
    enabled: !!stationIdFound,

    })


  return {
    energyActiveImportQuery,
    filter,
  }
}

export  function useStationData(measurand: MeasurandData ,stationId?: string) {
    const {stationId: stationIdUrl} = useSingleStation() 
  const {filter} = useFilterAnalysis()
    const stationIdFound = stationId || stationIdUrl;

    const dataQuery = useQuery({
    queryKey: ['data-station',measurand, stationId, filter],
    queryFn: () => getSationData(stationIdFound || "none", measurand, filter),
    enabled: !!stationIdFound,

    })


  return {
    dataQuery,
    filter,
  }
}